import { delay } from "apis"

export async function retryOnException(fn:() => Promise<any>, maxRetries:number, retryDelayMS:number, retryNum = 0):Promise<any> {
  try {
    const val = await fn()
    return val
  } catch(e) {
    if(retryNum < maxRetries) {
      console.log("retrying after delay")
      await delay(retryDelayMS)
      return await retryOnException(fn, maxRetries, retryDelayMS, retryNum + 1)
    } else {
      console.log("too many retries, rethrowing")
      throw e
    }
  }
}